import { Observable } from 'rxjs';
import { OwnerType } from '@vendasta/smsv2';

// A list of PIDs of partners to consider when determining if SMS messages will be sent via Broadly 1.0.
// NOTE: This is a front-end indicator only, the backend will determine the actual sending method.
export const BROADLY_SMS_PIDS = [
  'NBLY',
  'PRBS',
  'CHOW', // Used in demo for testing Broadly SMS features
];

export interface SmsRegistrationDependencies {
  // The type of the sms registration, a partner or an account
  ownerType: OwnerType;

  // The AGID of the account or the PID of the partner registering for SMS
  ownerId$: Observable<string>;

  // The Twilio subaccount ID of the account registering for SMS
  subaccountID$: Observable<string>;
}

// Provide contexts to services in the SMS lib about what entity operations are happening for
export interface SmsContext {
  // The ID of the entity using SMS right now (e.g. account group ID, partner ID, etc.)
  ownerId$: Observable<string>;
  // The type of entity
  ownerType: OwnerType;
  // Information for feature flags
  featureFlagInfo$: Observable<{
    partnerId: string;
    marketId?: string;
  }>;
  // Whether this owner sends SMS via Broadly 1.0
  sendsViaBroadly$: Observable<boolean>;
}
